export default {
    buttons: {
        save: 'Sačuvaj',
        go_to_location: 'Idi na lokacije',
        change_password: 'Promeni lozinku',
        change_email: 'Promeni email',
        eneter_email: 'Unesi email',
        add_credentials: 'Dodaj kredencijale',
        add_password: 'Dodaj lozinku',
        upload_profile_photo: 'Učitajte profilnu sliku',
        change_phone: 'Promeni broj telefona',
        enter_phone: 'Unesi broj telefona',
        verify_phone: 'Verifikuj broj telefona',
        change: 'Izmeni',
    },
    fields: {
        first_name: {
            label: 'Ime',
            placeholder: 'John',
        },
        last_name: {
            label: 'Prezime',
            placeholder: 'Jonhson',
        },
        username: {
            label: 'Korisničko ime',
            placeholder: 'Mora biti jedinstveno',
        },
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
        phone: {
            label: 'Broj telefona',
            placeholder: '+3811231231',
        },
        twitter: {
            label: 'X-Twitter',
            placeholder: 'Unesite X-Twitter link',
        },
        instagram: {
            label: 'Instagram',
            placeholder: 'Unesite Instagram link',
        },
        linkedin: {
            label: 'LinkedIn',
            placeholder: 'Unesite LinkedIn link',
        },
        facebook: {
            label: 'Facebook',
            placeholder: 'Unesite Facebook link',
        },
        description: {
            label: 'Opis',
            placeholder: 'Unesite opis...',
            description: 'Ovo je javna informacija koja ce se pokazati kada napravite rezervaciju',
        },
        tiktok: {
            label: 'Tik Tok',
            placeholder: 'Unesite Tik Tok link',
        },
        google: {
            label: 'Google Business',
            placeholder: 'Unesite Google Business link',
        },
    },
    messages: {
        confirm_email: 'Gotovo! Proverite vaš email.',
        locations_not_set: 'Trenutno nemate unetih lokacija. Da li želite da to uradite sada?',
        mobile_not_set: 'Niste uneli broj telefona. Da li želite da to uradite sada?',
        no_offers_active: 'Nemate aktivnih usluga.',
        no_offers_reneewal: 'Nemate usluga za obnovu.',
        no_offers_expired: 'Nemate isteklih usluga.',
        no_favorite_offers: 'Trenutno nema omiljenih usluga.',
    },
}
